import { useEffect } from 'react';
import Image from 'next/image';
import gsap from 'gsap';

const AnimCard4 = () => {
  useEffect(() => {
    gsap.context(() => {
      gsap
        .timeline({
          repeat: -1
        })
        .fromTo(
          '.anim-card-4-billete-js',
          {
            autoAlpha: 0,
            x: -10
          },
          {
            autoAlpha: 1,
            x: 0,
            ease: 'power2.out'
          }
        )
        .fromTo(
          '.anim-card-4-star-js',
          {
            autoAlpha: 0,
            y: 20
          },
          {
            autoAlpha: 1,
            y: 0,
            stagger: 0.3,
            ease: 'back.out'
          }
        )
        .to('.anim-card-4-billete-js', {
          x: -1,
          duration: 1
        });
    });
  }, []);

  return (
    <>
      <div className="absolute z-1 inset-0">
        <Image
          src="/images/animcards/4/chica.svg"
          width={228}
          height={193}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[26%] left-[39%] | anim-card-4-billete-js">
        <Image
          src="/images/animcards/4/billete.svg"
          width={25}
          height={12}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[13%] left-[34%] | anim-card-4-star-js">
        <Image
          src="/images/animcards/4/estrella.svg"
          width={13}
          height={13}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[11%] left-[41%] | anim-card-4-star-js">
        <Image
          src="/images/animcards/4/estrella.svg"
          width={13}
          height={13}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[9%] left-[48%] | anim-card-4-star-js">
        <Image
          src="/images/animcards/4/estrella.svg"
          width={13}
          height={13}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[11%] left-[55%] | anim-card-4-star-js">
        <Image
          src="/images/animcards/4/estrella.svg"
          width={13}
          height={13}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-[13%] left-[62%] | anim-card-4-star-js">
        <Image
          src="/images/animcards/4/estrella.svg"
          width={13}
          height={13}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
    </>
  );
};
export default AnimCard4;
